import Image from 'next/image'
import articleStyles from '../../styles/Article.module.css'
import { useEffect } from 'react'

export default function ArticleContent({content}) {

    useEffect(() => {

        async function Prism() {
            const prism = (await import('prismjs')).default
            require('prismjs/components/prism-python')
            prism.highlightAll();
          }


          Prism()
    }, [])

    const nextImage = (nextStr) => {
        const obj = JSON.parse(nextStr)

        return (
            <Image 
                src={obj.src}
                width={obj.width}
                height={obj.height}
                alt={obj.alt}
                key={obj.alt}
            />
        )
    }

    return(
        <>
            {content.map((x, index) => (
                x.includes('{"src":"') ?
                    nextImage(x)
                :
                    <div key={index} className={articleStyles.content} dangerouslySetInnerHTML={{ __html: x }}>
                    </div> 
            ))}
        </>
    )
}